import DataItem from '../data-items/common/data-item';
import { RESOURCES_TYPES_PROPS } from '../data-items/resource/resource-item';
/**
 * Data accumulator
 */

var DataSource = /*#__PURE__*/function () {
  function DataSource(item) {
    var _this = this;

    if (item === void 0) {
      item = null;
    }

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }
  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  var _proto = DataSource.prototype;

  _proto.clone = function clone() {
    return new DataSource(this.items.slice());
  }
  /**
   * Adds a new item.
   *
   * @param {Object | DataItem} item
   *
   * @return {DataSource} self
   */
  ;

  _proto.addItem = function addItem(item) {
    this.items.push(item instanceof DataItem ? item : new DataItem(item));
    return this;
  }
  /**
   * Merges all added items into one plain object.
   *
   * @returns {Object}
   */
  ;

  _proto.mergeItems = function mergeItems() {
    var res = {};

    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];

      if (!item.isActive()) {
        res = null;
        break;
      }

      var data = item["export"]();

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          // eslint-disable-line
          res[key] = data[key];
        }
      }
    }

    return res;
  }
  /**
   * Merges all added items into one plain object and sum up resource types props.
   *
   * @returns {Object}
   */
  ;

  _proto.mergePhasesItems = function mergePhasesItems() {
    var res = {};

    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];

      if (!item.isActive()) {
        res = null;
        break;
      }

      var data = item["export"]();

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          // eslint-disable-line
          if (RESOURCES_TYPES_PROPS.includes(key) && typeof res[key] === 'number') {
            res[key] += data[key];
          } else {
            res[key] = data[key];
          }
        }
      }
    }

    return res;
  };

  return DataSource;
}();

export { DataSource as default };